import { THEME } from '../generated/theme';

import { buildRestyleTheme } from './buildRestyleTheme';
import type { ThemeSelection } from './types';

const DEFAULT_MODE = 'light' as const;
const DEFAULT_BREAKPOINT = 'small' as const;

function hasOwn<T extends object>(obj: T, key: PropertyKey): key is keyof T {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

export function getTheme(selection: ThemeSelection) {
  const mode = hasOwn(THEME, selection.mode) ? selection.mode : DEFAULT_MODE;
  const byMode = THEME[mode];

  const breakpoint = hasOwn(byMode, selection.breakpoint) ? selection.breakpoint : DEFAULT_BREAKPOINT;
  const slice = byMode[breakpoint];

  return buildRestyleTheme(selection, slice);
}
